import { jsx as n, jsxs as o, Fragment as x } from "react/jsx-runtime";
import d from "classnames";
import { createElement as b } from "react";
import '../../../assets/FieldLabel.css';const p = "_label_17ewz_2", u = "_invalid_17ewz_19", w = "_astrix_17ewz_22", t = {
  label: p,
  "label-text": "_label-text_17ewz_14",
  invalid: u,
  astrix: w,
  "optional-text": "_optional-text_17ewz_27"
}, z = ({
  children: l,
  invalid: s,
  optionalText: e,
  required: a,
  as: i,
  readonly: c,
  className: _,
  ...m
}) => {
  const r = i || (c ? "strong" : "label");
  return b(
    r,
    { "data-testid": r, className: d(t.label, _), ...m },
    /* @__PURE__ */ o(x, { children: [
      /* @__PURE__ */ n("span", { "data-testid": "labelText", className: d(t["label-text"], { [t.invalid]: s }), children: l }),
      a && /* @__PURE__ */ n("sup", { "data-testid": "required", "aria-hidden": "true", className: t.astrix, children: "*" }),
      !a && e && /* @__PURE__ */ o("small", { "data-testid": "optionalText", className: t["optional-text"], children: [
        "— ",
        e
      ] })
    ] })
  );
}, v = ({ children: l, invalid: s, optionalText: e, required: a, ...i }) => /* @__PURE__ */ n(z, { invalid: s, optionalText: e, required: a, ...i, children: l });
export {
  v as default
};
